import { Briefcase, Rocket, Users, type LucideIcon } from 'lucide-react'
import { useLocation, useNavigate } from 'react-router'
import { lastPathFor, moduleOf, MODULE_START, type ModuleKey } from '@/lib/lastModule'
import { MODULE_LABELS } from '@/lib/labels'
import { cn } from '@/lib/utils'

const MODULES: readonly { key: ModuleKey; icon: LucideIcon }[] = [
  { key: 'preinvest', icon: Rocket },
  { key: 'postinvest', icon: Briefcase },
  { key: 'relaties', icon: Users },
]

/**
 * Pre-invest / Post-invest / Relaties, directly under the brand. Another module
 * opens where you left it; the active one goes back to its start.
 */
export function SectionSwitcher({ onNavigate }: { onNavigate?: () => void }) {
  const { pathname } = useLocation()
  const navigate = useNavigate()
  const active = moduleOf(pathname)
  return (
    <div role="group" aria-label="Onderdeel" className="vonk-switcher mb-2">
      {MODULES.map(({ key, icon: Icon }) => {
        const isActive = key === active
        return (
          <button
            key={key}
            type="button"
            aria-current={isActive ? 'page' : undefined}
            onClick={() => {
              navigate(isActive ? MODULE_START[key] : lastPathFor(key))
              onNavigate?.()
            }}
            className={cn('vonk-switcher__item', isActive && 'vonk-switcher__item--active')}
          >
            <Icon className="size-[18px] shrink-0" aria-hidden />
            {MODULE_LABELS[key]}
          </button>
        )
      })}
    </div>
  )
}
